'use client';

import { c as _c } from "react/compiler-runtime";
import { FOCUS_RING, INTERACTIVE_SURFACE } from '@common/components/interaction';
import { SvgClock, SvgDelete } from '@common/icon';
import { cn } from '@core/utils';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { EXIT_DURATION, FADE_DURATION, ROW_DELAY_SECONDS, ROW_FADE_DURATION, ROW_STAGGER_SECONDS } from './motion';
interface RecentSearchListProps {
  keywords: string[];
  onSelect: (keyword: string) => void;
  onRemove: (keyword: string) => void;
  onClearAll: () => void;
}
export function RecentSearchList(t0) {
  const $ = _c(26);
  const {
    keywords,
    onSelect,
    onRemove,
    onClearAll
  } = t0;
  const shouldReduceMotion = useReducedMotion();
  const duration = shouldReduceMotion ? 0 : FADE_DURATION;
  const exitDuration = shouldReduceMotion ? 0 : EXIT_DURATION;
  let t1;
  if ($[0] !== duration) {
    t1 = {
      duration,
      ease: "easeOut" as const
    };
    $[0] = duration;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fadeIn = t1;
  let t2;
  if ($[2] !== exitDuration) {
    t2 = {
      opacity: 0,
      transition: {
        duration: exitDuration,
        ease: "easeIn" as const
      }
    };
    $[2] = exitDuration;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const fadeOut = t2;
  let t3;
  if ($[4] !== shouldReduceMotion) {
    t3 = index => shouldReduceMotion ? 0 : ROW_DELAY_SECONDS + index * ROW_STAGGER_SECONDS;
    $[4] = shouldReduceMotion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const rowDelay = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="font-700 text-Gray-600 typo-caption1">최근 검색어</h2>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== fadeIn || $[8] !== fadeOut || $[9] !== keywords.length || $[10] !== onClearAll) {
    t5 = keywords.length > 0 && <motion.button key="clear-all" type="button" initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      transition: fadeIn
    }} exit={fadeOut} className={cn("-mx-4 rounded-xxsmall px-4 py-8 font-700 text-Gray-500 typo-caption1", "transition-colors duration-150 motion-reduce:transition-none", "hover:underline active:text-Gray-600 active:underline", FOCUS_RING)} onClick={onClearAll}>전체 삭제</motion.button>;
    $[7] = fadeIn;
    $[8] = fadeOut;
    $[9] = keywords.length;
    $[10] = onClearAll;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <div className="flex h-32 w-full items-center justify-between px-8">{t4}<AnimatePresence>{t5}</AnimatePresence></div>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== exitDuration || $[15] !== fadeIn || $[16] !== fadeOut || $[17] !== keywords || $[18] !== onRemove || $[19] !== onSelect || $[20] !== rowDelay || $[21] !== shouldReduceMotion) {
    t7 = <AnimatePresence mode="wait" initial={false}>{keywords.length === 0 ? <motion.p key="empty" initial={{
        opacity: 0
      }} animate={{
        opacity: 1,
        transition: fadeIn
      }} exit={fadeOut} className="px-8 py-20 text-Gray-500 typo-body4">최근 검색어가 없어요</motion.p> : <motion.ul key="list" exit={fadeOut} className="flex w-full flex-col"><AnimatePresence>{keywords.map((keyword, index_0) => <motion.li key={keyword} initial={{
            opacity: 0
          }} animate={{
            opacity: 1,
            transition: {
              duration: shouldReduceMotion ? 0 : ROW_FADE_DURATION,
              ease: "easeOut",
              delay: rowDelay(index_0)
            }
          }} exit={{
            opacity: 0,
            height: 0,
            transition: {
              duration: exitDuration,
              ease: "easeIn"
            }
          }} className="flex w-full items-center overflow-hidden"><button type="button" aria-label={`${keyword} 검색`} className={cn("flex min-w-0 flex-1 items-center gap-8 rounded-xxsmall px-8 py-10 text-left", INTERACTIVE_SURFACE)} onClick={() => onSelect(keyword)}><SvgClock className="size-16 shrink-0 text-Gray-400" /><span className="truncate tracking-[-0.28px] text-Gray-600 typo-body4">{keyword}</span></button><button type="button" aria-label={`${keyword} 삭제`} className={cn("shrink-0 rounded-xxsmall p-8 text-Gray-900", "transition-colors duration-150 motion-reduce:transition-none", "hover:text-R-500 active:text-R-600", FOCUS_RING)} onClick={() => onRemove(keyword)}><SvgDelete className="size-16" /></button></motion.li>)}</AnimatePresence></motion.ul>}</AnimatePresence>;
    $[14] = exitDuration;
    $[15] = fadeIn;
    $[16] = fadeOut;
    $[17] = keywords;
    $[18] = onRemove;
    $[19] = onSelect;
    $[20] = rowDelay;
    $[21] = shouldReduceMotion;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <section className="flex w-full flex-col gap-8 px-12">{t6}{t7}</section>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}